const STATUSES = {
  INITIAL: 0,
  PENDING: 1,
  SUCCESS: 2,
  ERROR: 3,
};

const makePaginationState = () => ({
  status: STATUSES.INITIAL,
  isLoaded: false,
  pagination: {
    page: 1,
    pages: 1,
    perPage: 20,
    hasPrev: false,
    hasNext: true,
    totalCount: 0,
    items: [],
  },
});

const makeOffsetPaginationState = () => ({
  status: STATUSES.INITIAL,
  isLoaded: false,
  pagination: {
    nextKey: null,
    hasPrev: false,
    hasNext: true,
    lastEvaluatedKey: null,
    totalCount: 0,
    items: [],
  },
});

const makeInitialState = () => ({
  status: STATUSES.INITIAL,
  isLoaded: false,
});

const makeDataState = () => ({
  status: STATUSES.INITIAL,
  isLoaded: false,
  data: {},
});

const makeListState = () => ({
  status: STATUSES.INITIAL,
  isLoaded: false,
  list: [],
});

const convertListToPagination = (listOrPagination) => {
  if (Array.isArray(listOrPagination)) {
    const list = listOrPagination;
    return {
      page: 1,
      pages: 1,
      perPage: list.length,
      hasPrev: false,
      hasNext: false,
      totalCount: list.length,
      items: list,
    };
  }

  return listOrPagination;
};

const isPreviouslyLoaded = (state, id) =>
  state.isLoaded && state.data.id === id;

const filterUnique = (arr1, ...arrList) =>
  arr1.reduce((acc, value) => {
    if (typeof value === 'string') {
      const redundant = arrList.some(
        (arr) => arr.findIndex((item) => value === item) !== -1
      );
      if (redundant) {
        return acc;
      }
    }

    const redundant = arrList.some(
      (arr) => arr.findIndex((item) => value.id === item.id) !== -1
    );
    if (redundant) {
      return acc;
    }

    return [...acc, value];
  }, []);

const concatUnique = (arr1, arr2) => {
  const uniqueList = filterUnique(arr2, arr1);
  return arr1.concat(uniqueList);
};

const checkAdRemove = (state) => {
  const adRemoveItem = state.market.inventories.list.find(
    (i) => i.marketItem.code === 'etc_ad_remove'
  );
  return adRemoveItem ? new Date(adRemoveItem.expired) > new Date() : false;
};

const getToken = (firebaseIdToken, accessToken) => {
  if (firebaseIdToken) {
    return `FIT ${firebaseIdToken}`;
  } else if (accessToken) {
    return `JWT ${accessToken}`;
  }

  return null;
};

const getTokenFromState = (state) => {
  const { firebaseIdToken, accessToken } = state.common;
  return getToken(firebaseIdToken, accessToken);
};

export default {
  STATUSES,
  makeInitialState,
  makePaginationState,
  makeOffsetPaginationState,
  makeDataState,
  makeListState,
  convertListToPagination,
  isPreviouslyLoaded,
  filterUnique,
  concatUnique,
  checkAdRemove,
  getToken,
  getTokenFromState,
};



// WEBPACK FOOTER //
// ./src/app/utils/redux.js